import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Label } from "../ui/label";
import { JUNIOR_HOW_DEFAULTS, JUNIOR_HOW_GROUPS } from "../../lib/juniorHow";
import { NavHowItWorks } from "../nav/NavHowItWorks";

// Grids that use every feature, so the preview shows every line the admin can edit (Mines + a Moon grid for the world lines)
const PREVIEW_NAV = {
  start: { x: 0, y: 9, dir: "N" }, treasure: { x: 9, y: 0 }, rocks: [{ x: 3, y: 3 }], dangers: [{ x: 5, y: 5 }], powers: [{ x: 0, y: 6 }],
  tunnels: [{ letter: "A", a: { x: 1, y: 1 }, b: { x: 8, y: 8 } }], max_blocks: 12, excluded_categories: [], excluded_blocks: [],
};
const PREVIEW_MOON = {
  world: "moon", start: { x: 0, y: 9, dir: "N" }, goals: [{ x: 9, y: 0 }, { x: 4, y: 4 }], fuel: 5, fuel_cells: [{ x: 0, y: 6 }],
  rocks: [{ x: 3, y: 3 }], dangers: [{ x: 5, y: 5 }], tunnels: [], max_blocks: null, excluded_categories: ["logic"], excluded_blocks: [],
};

// Admin -> Content: one entry per "How it works" line of Junior Blocks grids, with a live preview.
export function JuniorHowEditor({ value, onChange }) {
  const set = (field, text) => onChange({ ...value, [field]: text });
  const preview = Object.fromEntries(Object.keys(JUNIOR_HOW_DEFAULTS).map((k) => [k, (value[k] ?? "").trim() || JUNIOR_HOW_DEFAULTS[k]]));
  return (
    <div className="grid gap-5 xl:grid-cols-[1fr_minmax(320px,40%)]" data-testid="content-junior-how">
      <div className="space-y-5">
        {JUNIOR_HOW_GROUPS.map((group) => (
          <div key={group.id} className="space-y-3" data-testid={`content-junior-how-group-${group.id}`}>
            <div>
              <h4 className="font-semibold text-sm uppercase tracking-wider text-muted-foreground">{group.title}</h4>
              <p className="text-xs text-muted-foreground">{group.hint}</p>
            </div>
            <div className={group.kind === "input" ? "grid gap-3 sm:grid-cols-3" : "grid gap-3 md:grid-cols-2"}>
              {group.fields.map(([field, label]) => (
                <div key={field} className="space-y-1">
                  <Label htmlFor={`junior-how-${field}`} className="text-xs">{label}</Label>
                  {group.kind === "input" ? (
                    <Input id={`junior-how-${field}`} value={value[field] ?? ""} onChange={(e) => set(field, e.target.value)} placeholder={JUNIOR_HOW_DEFAULTS[field]} data-testid={`content-junior-how-${field}`} />
                  ) : (
                    <Textarea id={`junior-how-${field}`} rows={3} value={value[field] ?? ""} onChange={(e) => set(field, e.target.value)} placeholder={JUNIOR_HOW_DEFAULTS[field]} data-testid={`content-junior-how-${field}`} />
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
        <p className="text-xs text-muted-foreground">Wrap words in double asterisks to make them bold, e.g. <code>**Play**</code>. Leave a box empty to fall back to the built-in text.</p>
      </div>
      <div className="space-y-2 xl:sticky xl:top-4 self-start">
        <p className="text-xs uppercase tracking-wider text-muted-foreground">Preview (Mines grid with every feature)</p>
        <NavHowItWorks nav={PREVIEW_NAV} text={preview} />
        <p className="text-xs uppercase tracking-wider text-muted-foreground pt-2">Preview (Moon grid: 2 samples, fuel cell, crack)</p>
        <NavHowItWorks nav={PREVIEW_MOON} text={preview} />
      </div>
    </div>
  );
}
